import { mixpanelTrack } from "./mixpanelTrack";

// Tactics client-side Mixpanel events. Pure-client interactions (explore / copy
// / view / sort / filter) live here; the user-investment `favourite` action is
// fired server-side in peareasy-services instead.
//
// Mirrors events/evolutionsMixpanel.ts. Tactics has a single subsection
// ("Overview"), so it's hard-coded here rather than passed in.

const SECTION = "Tactics";
const SUBSECTION = "Overview";

export const trackExplore = (params: {
  source: string;
  destination_section: string;
  destination_subsection: string;
  new_content?: boolean;
}) =>
  mixpanelTrack("explore", {
    section: SECTION,
    subsection: SUBSECTION,
    source: params.source,
    destination_section: params.destination_section,
    destination_subsection: params.destination_subsection,
    new_content: params.new_content ?? false,
    action_type: "core",
  });

export const trackCopyTacticsCode = () =>
  mixpanelTrack("copy_tactics_code", {
    section: SECTION,
    subsection: SUBSECTION,
    action_type: "core",
  });

export const trackViewContent = (params: { new_content?: boolean }) => {
  mixpanelTrack("view_content", {
    section: SECTION,
    subsection: SUBSECTION,
    content_type: "tactic",
    new_content: params.new_content ?? false,
    action_type: "browse",
  });
};

export const trackSort = (params: { value: string }) => {
  const value = params.value === "date-added" ? "new" : params.value;
  mixpanelTrack("sort", {
    section: SECTION,
    subsection: SUBSECTION,
    value,
    action_type: "browse",
  });
};

// Fired when the user closes the filters panel. `filters` is the list of active
// filter keys.
export const trackFilter = (params: { filters: string[] }) =>
  mixpanelTrack("filter", {
    section: SECTION,
    subsection: SUBSECTION,
    filters: params.filters,
    action_type: "browse",
  });
